module.exports = __webpack_public_path__ + "img/img_brand23.3fc4354f.jpg";